import React from "react";

import AnswerMapping from "./AnswerMapping";
import useTranslations from "../../hooks/useTranslations";
import { useBreadcrumbs } from "../../hooks/useBreadcrumbs";

const QuestionMapping: React.FC = () => {
    const t = useTranslations();
  
    useBreadcrumbs([
      {
        to: "/analytics/question-mapping",
        text: t("statistics.questions") as string,
      },
    ]);
    
    return (
      <AnswerMapping
        title={t("statistics.questions")}
        description={t("statistics.statisticsQuestionsDescription")}
        questionTypes={[ "QuestionSelectorSingle" ]}
        defaultIsCollaborator={false}
      />
    )
}

export default React.memo(QuestionMapping)